import { TariffZoneApiModel } from './tariff-zone.api-model';
import { StopPointApiModel } from '../journeys/stop-point.api-model';
import type { ICallDetails } from '../../../../models/call-details.model';
import type { IOccupancy } from '../../../../models/occupancy.model';

export class CallDetailsApiModel {
  public static mapToBusinessModel(apiModel: CallDetailsApiModel): ICallDetails {
    return {
      index: apiModel.index,
      plannedPlatform: apiModel.plannedPlatform,
      estimatedArrivalTime: apiModel.estimatedArrivalTime,
      isCancelled: apiModel.isCancelled,
      estimatedDepartureTime: apiModel.estimatedDepartureTime,
      estimatedPlatform: apiModel.estimatedPlatform,
      isOnTripLeg: apiModel.isOnTripLeg,
      isTripLegStart: apiModel.isTripLegStart,
      isTripLegStop: apiModel.isTripLegStop,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      plannedArrivalTime: apiModel.plannedArrivalTime,
      plannedDepartureTime: apiModel.plannedDepartureTime,
      tariffZones: apiModel.tariffZones ? apiModel.tariffZones.map(TariffZoneApiModel.mapToBusinessModel) : undefined,
      occupancy: apiModel.occupancy ? apiModel.occupancy : undefined,
      stopPoint: StopPointApiModel.mapToBusinessModel(apiModel.stopPoint),
    };
  }

  public plannedDepartureTime?: string;
  public plannedArrivalTime?: string;
  public estimatedDepartureTime?: string;
  public estimatedArrivalTime?: string;
  public plannedPlatform!: string;
  public estimatedPlatform?: string;
  public latitude?: number;
  public longitude?: number;
  public index!: string;
  public isCancelled!: boolean;
  public isOnTripLeg?: boolean;
  public isTripLegStart?: boolean;
  public isTripLegStop?: boolean;
  public tariffZones?: TariffZoneApiModel[];
  public occupancy?: IOccupancy;
  public stopPoint!: StopPointApiModel;
}
